import React, { ReactElement } from 'react';
import './VoiceGuestBtn.scss';
import { IResponseUserPairData } from '../../../../services/api/models/response/responseVoicePlus';
import { ImageCustom } from '../../../../common/components/ImageCustom';
import circleNotAcceptPair from '../../../../assets/svg/bosyuu4_frame.svg';
import circleAcceptPair from '../../../../assets/svg/bosyuu1_frame.svg';
import microAction from '../../../../assets/png/syuhasuu.png';
import { AppState } from '../../../../store/store';
import { useSelector } from 'react-redux';
interface VoiceGuestBtnProps {
  audientGuest?: IResponseUserPairData;
  callBackToggleModal?: () => void;
}

export const VoiceGuestBtn = (props: VoiceGuestBtnProps): ReactElement => {
  const { audientGuest, callBackToggleModal } = props;
  const liveState = useSelector((state: AppState) => state.live);
  return (
    <div className="voice-guest__btn" onClick={callBackToggleModal}>
      {audientGuest ? (
        <img
          className="voice-guest__icon-img"
          src={audientGuest.picture?.uri}
          alt={audientGuest.loginId}
        />
      ) : (
        <>
          {liveState.isAcceptPair ? (
            <ImageCustom
              className="voice-guest__icon-btn"
              src={circleAcceptPair}
            />
          ) : (
            <ImageCustom
              className="voice-guest__icon-btn"
              src={circleNotAcceptPair}
            />
          )}
        </>
      )}
      {audientGuest ? `${audientGuest.loginId}` : 'NO GUEST'}

      {liveState.userPair && (
        <ImageCustom className="voice-guest__micro-action" src={microAction} />
      )}
    </div>
  );
};
